import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { DrawdownSinglePaymentInstructionArrangementSelectionClient } from "../../../../../../Wrap/Api/Drawdown/DrawdownSinglePaymentInstructionArrangementSelection";
import { DrawdownSinglePaymentInstructionArrangementSelection } from "../../../../../../Wrap/Models/Domains/Drawdown/DrawdownSinglePaymentInstructionArrangementSelection";
import { IncomePaymentOneOffDispatcher, IncomePaymentOneOffStore } from "../Store/Variable";

export class IncomePaymentOneOffAction {

    public static getInstruction(id: number, subAccountHierarchyId: string, clientId: number): void {
        const client = new DrawdownSinglePaymentInstructionArrangementSelectionClient();

        if (id && id !== 0) {
            const promise = client.get(id,subAccountHierarchyId,clientId);
            this.updateSPTInstructionStore(promise);
            return;
        }

        // Create new instruction
        const promise = client.post(subAccountHierarchyId, clientId, null);
        this.updateSPTInstructionStore(promise);
    }

    public static saveInstruction(instructionId: number, instruction: DrawdownSinglePaymentInstructionArrangementSelection, callback?: (error) => void): void {
        const client = new DrawdownSinglePaymentInstructionArrangementSelectionClient();
        const promise = client.put(instructionId, instruction, false);
        
        promise.onSuccess(() => {
            let data = JSON.parse(JSON.stringify(IncomePaymentOneOffStore.getData()));
            if (!data) {data = {};}
            data.Instruction = instruction;
            IncomePaymentOneOffDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });

            if (callback) {callback([]);}
        });
    }

    public static submitInstruction(instructionId: number, data: DrawdownSinglePaymentInstructionArrangementSelection, callback?: (error) => void): void {
        const client = new DrawdownSinglePaymentInstructionArrangementSelectionClient();
        const promise = client.put(instructionId, data, true);

        promise.onSuccess((result) => {
            if (callback) {callback(result);}
        });

        promise.onError((err) => {
            IncomePaymentOneOffDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });

    }

    public static deleteInstruction(id: number, callback?: VoidFunction): void {
        if (!id) {
            callback();
            return;
        }

        const client = new DrawdownSinglePaymentInstructionArrangementSelectionClient();
        const promise = client.delete(id);
        promise.onSuccess(() => {
            if (callback) {callback();}
        });
    }

    private static updateSPTInstructionStore(promise: any, callback?: (data) => void) {
        promise.onSuccess((result) => {
            let data = JSON.parse(JSON.stringify(IncomePaymentOneOffStore.getData()));
            if (!data) {data = {};}
            data = result;
            IncomePaymentOneOffDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
            if (callback) {callback([]);}
        });

        promise.onError((err) => {
            IncomePaymentOneOffDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }
}
